import ENV from 'client-portal/config/environment';

const SUPPORTED_AVAILABILITY_ERROR_CODES = new Set([400, 500, 503]);

export function clinicianSearchAvailabilityErrorCodeFromMeta(meta) {
  let c = meta?.errorCode;
  return typeof c === 'number' && SUPPORTED_AVAILABILITY_ERROR_CODES.has(c) ? c : null;
}

export function buildClinicianSearchConsumerMeta(rawMeta = {}, options = {}) {
  let defaultPageSize = options.defaultPageSize ?? 10;
  let maxPages = ENV.clinicianSearchMaxPages ?? 42;

  let p = rawMeta.page ?? {};
  let number = p.number ?? 1;
  let pageSize = p.pageSize ?? defaultPageSize;
  let total = p.total ?? 0;

  let totalPages = pageSize > 0 ? Math.ceil(total / pageSize) : 0;
  let searchWindowMaxResults = maxPages * pageSize;
  let showCappedFilteredResults = searchWindowMaxResults > 0 && total >= searchWindowMaxResults;
  let filteredResultsCappedCount = Math.max(0, searchWindowMaxResults - 1);

  let errorCode = clinicianSearchAvailabilityErrorCodeFromMeta(rawMeta);

  return {
    page: {
      number,
      pageSize,
      total,
    },
    totalPages,
    summary: {
      fullClinicianCount: total,
      searchWindowMaxResults,
      showCappedFilteredResults,
      filteredResultsCappedCount,
    },
    availability: {
      errorCode,
      errorCodeSignature: String(errorCode ?? ''),
    },
  };
}
